import React, { useMemo } from "react"

import { ListItemIcon as MuiListItemIcon, Skeleton } from "@mui/material"
import { styled } from "@mui/styles"

import { Selector } from "@cirrus/ui-kit-ts"

import { flags } from "./flags"
import { LanguageCode } from "../../CustomerInfo/types"
import { useTranslationsContext } from "../providers/Translations"

const LANGUAGE_SELECTOR_ID = "language-selector-id"

export const LanguageSelector = () => {
  const { changeLanguage, language, availableLanguages, loading } = useTranslationsContext()

  const languages = useMemo(() => Object.keys(availableLanguages ?? {}).map((languageCode) => ({
    value: languageCode,
    title: availableLanguages[languageCode] ?? "",
    startContent: flags[languageCode]
  })), [availableLanguages])

  return loading
    ? <Skeleton variant="rectangular" height={44} />
    : <>
      <label htmlFor={`${LANGUAGE_SELECTOR_ID}-input`} style={{ position: "absolute", left: -9999 }}>
        {LANGUAGE_SELECTOR_ID}
      </label>
      <Selector
        id={LANGUAGE_SELECTOR_ID}
        options={languages}
        defaultValue={language ?? languages[0].value}
        disableUnderline
        hideInput
        onChange={({ target }) => changeLanguage(target.value as LanguageCode)}
        renderValue={(selected) => <SelectedLanguage selected={selected} languages={languages} />}
        renderOptionContent={(option) => <LanguageOptionContent option={option} />}
      />
    </>
}

const ListItemIcon = styled(MuiListItemIcon)({
  minWidth: "auto !important", marginRight: "1rem"
})

const OptionText = styled("span")({
  fontWeight: 600, fontSize: "14px"
})

const SelectedLanguage = ({ selected, languages }) => {
  const selectedLanguage = languages.find(({ value }) => value === selected)

  return !!selectedLanguage ? <div>
    <ListItemIcon>{flags[selectedLanguage.value]}</ListItemIcon>
    <OptionText>{selectedLanguage.title}</OptionText>
  </div> : null
}

const LanguageOptionContent = ({ option }) => <>
  <ListItemIcon>{flags[option.value]}</ListItemIcon>
  <OptionText>{option.title}</OptionText>
</>
